import type { DeepString } from "@/lib/i18n";

/**
 * WNewsletter - polskie tłumaczenia.
 *
 * Fallback gdy backend `content.lang.*` nie dostarczy stringa + komunikaty
 * walidacyjne + etykiety popupa.
 */
export const pl = {
  /** Brak danych konfiguracji okna. */
  noConfig: "Brak danych konfiguracji okna newslettera.",
  /** Brak skonfigurowanego katalogu zapisu (id_catalog). */
  noCatalog:
    "Okno newslettera nie ma przypisanej strony zapisu. Skonfiguruj powiązany katalog w panelu administracyjnym.",

  /** Fallback nagłówka zachęcającego. */
  info: "Otrzymuj od nas informacje!",
  /** Fallback placeholdera pola e-mail. */
  typeEmail: "wpisz adres e-mail",
  /** Fallback etykiety przycisku. */
  save: "Zapisz się",

  /** Aria-label przycisku zamknięcia popupa. */
  closeLabel: "Zamknij",

  /* ─── Walidacja ─── */
  validation: {
    requiredEmail: "Podaj adres e-mail.",
    invalidEmail: "Niepoprawny adres e-mail.",
    requiredConsent: "Wymagana zgoda na przetwarzanie danych osobowych.",
  },
} as const;

export type WNewsletterTranslations = DeepString<typeof pl>;
